const PLURAL_DICTIONARY: Record<string, string> = {
  "browser tab": "browser tabs",
  bundle: "bundles",
  credit: "credits",
  domain: "domains",
  file: "files",
  font: "fonts",
  item: "items",
  page: "pages",
  product: "products",
  "product template": "product templates",
  project: "projects",
  "published element (25)": "published elements",
  "published element": "published elements",
  section: "sections",
  "shopify theme builder project": "shopify theme builder projects",
  "shopify project": "shopify projects",
  site: "sites",
  store: "stores",
  variant: "variants",
};

export function pluralize(word: string, count: number): string {
  const key = word.toLowerCase();
  if (count === 1) {
    return word;
  }
  const plural = PLURAL_DICTIONARY[key];
  if (!plural) {
    return word;
  }
  return matchCase(word, plural);
}

function matchCase(source: string, target: string) {
  if (source === source.toUpperCase()) {
    return target.toUpperCase();
  }
  return target
    .split("")
    .map((char, i) => {
      if (i < source.length && source[i] !== source[i]!.toLowerCase()) {
        return char.toUpperCase();
      }
      return char;
    })
    .join("");
}
